import Vue from 'vue';
import _ from 'lodash';
import ToastComponent from './toast.vue';

let instance;
// toast 是否存在的标记位
let installed = false;

const ToastConstructor = Vue.extend(ToastComponent);

const initInstance = () => {
    instance = new ToastConstructor({
        el: document.createElement('div'),
    });
    document.body.appendChild(instance.$el);
};

const Toast = (options) => {
    let msg = '';
    let duration = 2000;
    let showMsg = false;
    if (typeof options === 'string') {
        msg = options;
    } else if (typeof options === 'object') {
        console.log(options);
        if (_.has(options, 'msg')) {
            msg = options.msg;
        }
        if (_.has(options, 'duration')) {
            duration = options.duration;
        }
        if (_.has(options, 'showMsg')) {
            showMsg = options.showMsg;
        }
    }
    // 如果没有实例化，则实例化
    if (!installed) {
        installed = true;
        initInstance();
    }
    instance.show = true;
    instance.msg = msg;
    instance.showMsg = showMsg;
    setTimeout(() => {
        instance.show = false;
    }, duration);
};

export default {
    install(vue) {
        vue.prototype.$toastV2 = Toast;
    },
};
